module.exports = __webpack_public_path__ + "static/media/wave-sine.73cf53d0.svg";